import type { TestId } from '@repo/test-id';
import { Carousel } from '@repo/ui';

import EntranceCarParkedSlide from '@features/promo/components/entrance/EntranceCarParkedSlide';
import EntranceGoldenWalletSlide from '@features/promo/components/entrance/EntranceGoldenWalletSlide';
import EntranceStatisticsSlide from '@features/promo/components/entrance/EntranceStatisticsSlide';
import EntrancePhoneRingingSlide from '@features/promo/components/entrance/EntrancePhoneRingingSlide';

interface Props {
  testId: TestId;
}

export default function EntranceCarousel({ testId }: Props) {
  return (
    <Carousel testId={testId} autoSlide={5000}>
      <EntranceCarParkedSlide testId={testId.append('carParked')} />
      <EntranceGoldenWalletSlide testId={testId.append('goldenWallet')} />
      <EntranceStatisticsSlide testId={testId.append('statistics')} />
      <EntrancePhoneRingingSlide testId={testId.append('phoneRinging')} />
    </Carousel>
  );
}
